import React, { useState } from 'react';
import { FiFileText, FiChevronRight, FiCalendar } from "react-icons/fi";
import '../../styles/GSIDA.css';

const publications = [
  { id: 1, title: "L'IA et la Sécurité en Zone Afro-Méditerranéenne", date: "Janvier 2025", type: "Rapport Stratégique", desc: "Analyse exhaustive de l'impact de l'IA sur la résilience des institutions publiques en Afrique du Nord.", detail: "Ce rapport explore les vulnérabilités infrastructurelles et propose des modèles de déploiement sécurisé pour les administrations au Maroc, en Égypte et en Tunisie." },
  { id: 2, title: "Gouvernance des Données Massives : Enjeux de Souveraineté", date: "Novembre 2024", type: "Livre Blanc", desc: "Comment protéger les données critiques nationales face aux architectures Big Data mondiales ?", detail: "Livre blanc détaillant les cadres juridiques nécessaires pour assurer une gestion souveraine des informations stratégiques." },
  { id: 3, title: "Cybersécurité et Architectures Réseaux", date: "Mars 2024", type: "Étude Technique", desc: "Recherche sur les protocoles de protection des réseaux critiques.", detail: "Une étude technique approfondie sur la sécurisation des échanges inter-institutionnels via des protocoles cryptographiques avancés." },
];

export default function GSIDAPublications() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="gsida-publications-page">
      <div className="gsida-header-banner publications-banner">
         <div className="banner-overlay">
            <h1>Publications GSIDA</h1>
            <p>Rapports, Études et Livres Blancs de l'Institut</p>
         </div>
      </div>

      <div className="gsida-content-container">
         <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Nos Publications Récentes</h3>
          </div>

        

        <div className="publications-layout">
         
           <div className="pub-grid">
              {publications.map(p => (
                <div className={`pub-card ${selected === p.id ? 'active' : ''}`} key={p.id} onClick={() => setSelected(p.id)}>
                   <div className="pub-card-head">
                   
                      <span className="pub-type">{p.type}</span>
                   </div>
                   <p style={{ marginBottom: '10px'}}>{p.title}</p>
                   <p className="pub-short">{p.desc}</p>
                   <div className="pub-meta">
                      <FiCalendar /> <span>{p.date}</span>
                      <FiChevronRight className="arrow" />
                   </div>
                </div>
              ))}
           </div>

           <div className="pub-detail-view">
              {selected ? (
                <div className="detail-inner">
                   <h3>{publications.find(p => p.id === selected).title}</h3>
                   <span className="detail-badge">{publications.find(p => p.id === selected).type}</span>
                   <p className="detail-text">{publications.find(p => p.id === selected).detail}</p>
                   <button className="download-cta">Télécharger le document complet</button>
                </div>
              ) : (
                <div className="detail-empty">
                   <FiFileText size={50} />
                   <p>Sélectionnez une publication pour voir les détails</p>
                </div>
              )}
           </div>
        </div>
      </div>
    </div>
  );
}
